export default __webpack_public_path__ + "static/media/work_portfolio_work.792f2b57.jpg";